import { AppLink } from '../../../components/AppLink';
import { Button } from '../../../components/Button';
import { FlexColPageContainer } from '../../../components/FlexColPageContainer';
import { useUserData } from '../../../lib/userData/UserDataProvider';
import { EmotionsPickerForm } from './EmotionsPickerForm';

export const metadata = {
  title: 'Mood Step 2 | Patchooli',
  description: 'Mood Log Entry | Step 2 | Patchooli',
};

export const MoodLogEntryStep2Page = () => {
  const [userData] = useUserData();
  const { firebaseUserId: uid, profile } = userData || {};
  const displayName = profile?.firstName || 'friend';

  if (!uid || !displayName) {
    return (
      <FlexColPageContainer>
        <div className="mx-auto my-3 w-10/12 text-center">
          <h1 className="text-2xl text-black">Please login to continue.</h1>
          <Button as={AppLink} href="/login" variant="buttonPrimary">
            Login
          </Button>
        </div>
      </FlexColPageContainer>
    );
  }

  return <EmotionsPickerForm userId={uid} displayName={displayName} />;
};
